import { Injector } from '@futrli/shared-services';

/**
 * Injector represents the dependency injection coding pattern, in which a class receives its dependencies
 * from external sources rather than creating them itself.
 */
const injector = new Injector();

export { injector };
